export default function getImage(img) {
    if (img && !img.startsWith('http')) {
        img = 'https://sliceq.com' + img;
    }
    return img;
}
